import { render } from "./KoyuSwitcher.vue?vue&type=template&id=f5a688d8&scoped=true"
import script from "./KoyuSwitcher.vue?vue&type=script&lang=js"
export * from "./KoyuSwitcher.vue?vue&type=script&lang=js"

import "./KoyuSwitcher.vue?vue&type=style&index=0&id=f5a688d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a688d8"]])

export default __exports__